<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
					<v-btn
						icon
						dark
						small
						:color="color"
						class="mr-2"
						v-bind="{ ...tooltipAttrs, ...menuAttrs }"
						v-on="{ ...tooltipOn, ...menuOn }"
					>
						<v-icon small>mdi-credit-card-clock-outline</v-icon>
					</v-btn>
				</template>
				<span>Historial de pagos para la cuota</span>
			</v-tooltip>
		</template>
		<v-list dense class="py-0 white">
			<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
				<div>
					<p class="caption mb-0 font-weight-bold white--text">Historial</p>
				</div>
			</v-list-item>
			<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
				<div class="d-flex align-center flex-grow-1">
					<p class="caption mb-0 text--disabled" style="width: 150px;">Forma Pago</p>
					<p class="caption mb-0 text--disabled" style="width: 120px;">Fecha Pago</p>
					<p class="caption mb-0 text--disabled text-end" style="width: 70px;">Monto</p>
					<p class="caption mb-0 text--disabled text-end" style="width: 120px;">Comprobante</p>
				</div>
			</v-list-item>
			<v-divider></v-divider>
			<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
				<v-list-item
					v-for="(payment, index) in payments"
					:key="'paymenthistory-'+index"
					dense
					style="min-width: 380px;"
					class="white"
				>
					<v-list-item-title dense>
						<div class="d-flex align-center item-background-hover">
							<div class="d-flex align-center caption" style="width: 150px;">
								<p class="mb-0 caption text-end">{{payment.payment_info?.method}}</p>
							</div>
							<div class="d-flex align-center caption" style="width: 120px;">
								<p class="mb-0 caption text-end">{{payment.payment_info?.payment_date | toDate}}</p>
							</div>
							<div class="d-flex align-center justify-end caption" style="width: 70px;">
								<p class="mb-0 caption text-end">${{payment.payment_info?.amount | toThousandFilter}}</p>
							</div>
							<div class="d-flex align-center justify-end caption" style="width: 120px;">
								<div class="rounded ma-1 pa-1 d-flex flex-column justify-center"
									v-if="payment.file"
									@click="$store.commit('general/setSelectedFile',{file: payment.file, to_modal: true})"
								>
									<v-icon :color="getIconFile(payment.file).color">{{getIconFile(payment.file).icon}}</v-icon>
								</div>
								<div v-else><p class="mb-0" style="font-size: 10px">Sin Comprobante</p></div>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>

<script>
// import moment from "moment"

export default {
	name: 'PaymentHistory',
	props: {
		payments: {
			type: Array,
			required: true
		},
		color: {
			type: String,
			default: 'rgba(0, 0, 0, 0.87)'
		},
	},
	data() {
		return{
		}
	},
	mounted(){
	},
	methods: {
		getIconFile(file){
			const fileExtension = file.path.split('.').pop().toLowerCase();
			if (fileExtension === 'pdf') {
					return { icon: 'mdi-file-pdf-box', color: '#FF0000' };
			} else if (fileExtension === 'doc' || fileExtension === 'docx') {
					return { icon: 'mdi-file-word', color: '#1E88E5' };
			} else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
					return { icon: 'mdi-file-excel', color: '#4CAF50' };
			} else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
					return { icon: 'mdi-file-image', color: '#FFD700' };
			} else {
					return { icon: 'mdi-file', color: '#9E9E9E' };
			}
		},
	}
}
</script>

<style scoped>
	.file-icon-buttons{
		width: 70px;
		height: 80px;
		border: 1px solid rgb(213, 211, 211);
		cursor: pointer;
	}
	.file-icon-buttons:hover{
		background-color: rgb(239, 239, 239);
	}
	.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
	}
</style>